import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { Actions as PAYSCHEDULEACTIONS } from "../../../store/actions/payScheduleActions";
import { Actions as COMPANYACTIONS } from "../../../store/actions/companyActions";
import { Actions as PAYPERIODACTIONS } from "../../../store/actions/payPeriodActions";
import { ChevronDownIcon, InformationCircleIcon } from "@heroicons/react/20/solid";
import Tooltip from "@/tooltip";
import { validateInteger } from "../../common/validation/Validators";
import { payFrequencyOptions } from "../config/PayScheduleTypes";

const PaySchedule = ({
	paySchedule,
	updateSetting,
	periodsUsingSchedule,
	disabled,
	payFrequency,
	payDeadlineType,
	payDayType,
	type,
	showUpdatePeriodTypeModal,
	payFrequencyOptions,
	payDeadlineOptions,
	payDayOptions,
	payDayDurationOptions,
	payPeriods,
	getPayPeriods,
	cutOffsDurationOptions,
	hasMultipleSchedules,
	cutOffOptions,
}) => {
	const [expand, setExpand] = useState(false);

	useEffect(() => {
		if (!payPeriods?.length) getPayPeriods();
	}, [payPeriods?.length]);

	return (
		<div className="col-xs-12 pr-0 form-inner-section mb-0 pb-0 pt-6">
			<div className="col-xs-2 pl-0">
				<div className="form-material">
					<input
						style={{ maxWidth: "100%" }}
						name="name"
						value={paySchedule?.name}
						className="form-control form-input"
						disabled={disabled}
						onChange={(e) => updateSetting(paySchedule?.id, e.target.name, e.target.value)}
						defaultValue={paySchedule?.name}
					/>
					<label>Name</label>
					<div className="clearfix" />
				</div>
			</div>
			<div className="col-xs-2 pl-0">
				<div className="form-material">
					<Select
						options={payFrequencyOptions}
						style={{ width: "100px" }}
						valueName="selected"
						isDisabled={disabled || periodsUsingSchedule > 1}
						value={payFrequencyOptions.find((option) =>
							paySchedule?.type
								? paySchedule?.type == option.value
								: option.payFrequency == paySchedule?.payFrequency,
						)}
						defaultValue={payFrequencyOptions.find((option) => option.label === "every month")}
						onChange={(e) => {
							if (periodsUsingSchedule) {
								showUpdatePeriodTypeModal(paySchedule?.id, e.value);
							} else {
								updateSetting(paySchedule?.id, "type", e.value);
								updateSetting(paySchedule?.id, "payFrequency", e.payFrequency);

								if (e.value == "4-4-5" || e.payFrequency !== 12) {
									if (!payDayType || payDayType === "of the month")
										updateSetting(
											paySchedule?.id,
											"payDay",
											payDayOptions.filter((p) => p.value !== "of the month")?.[0].value,
											"type",
										);
									if (!payDeadlineType || payDeadlineType === "of the month")
										updateSetting(paySchedule?.id, "deadline", payDeadlineOptions[0].value, "type");
								}
							}
						}}
					/>
					<label>Pay Frequency</label>
					<div className="clearfix" />
				</div>
				<div className="clearfix" />
			</div>
			<div className="col-xs-3 pl-0">
				<div className="form-material">
					<input
						type="number"
						className="form-control form-input"
						max="31"
						min="1"
						style={{
							width: "calc(25% - 5px)",
							display: "inline-block",
						}}
						disabled={disabled}
						name="deadline"
						value={paySchedule?.deadline?.value}
						onChange={(e) => updateSetting(paySchedule?.id, e.target.name, e.target.value, "value")}
						defaultValue={paySchedule?.deadline?.value}
					/>
					<div
						style={{
							width: "calc(75% - 5px)",
							display: "inline-block",
							marginLeft: "5px",
						}}
					>
						<Select
							options={
								type != "4-4-5" || payFrequency == 12
									? payDeadlineOptions
									: payDeadlineOptions.filter((p) => p.value != "of the month")
							}
							valueName="selected"
							placeholder="Choose one"
							isDisabled={disabled}
							value={payDeadlineOptions.find(
								(payDeadline) => payDeadline.value == paySchedule?.deadline?.type,
							)}
							onChange={(e) => updateSetting(paySchedule?.id, "deadline", e.value, "type")}
						/>
					</div>
					<label>Payroll Deadline</label>
					<div className="clearfix" />
				</div>
			</div>
			<div className={`col-xs-${["of the period"].includes(paySchedule?.payDay?.type) ? 2 : 1} pl-0`}>
				<div className="form-material">
					<label>Payday</label>
					{["of the period"].includes(paySchedule?.payDay?.type) ? (
						<Select
							options={payDayDurationOptions}
							valueName="selected"
							placeholder="Choose one"
							isDisabled={disabled}
							value={payDayDurationOptions.find(
								(pdDuration) => pdDuration.value == paySchedule?.payDay?.value,
							)}
							onChange={(e) => updateSetting(paySchedule?.id, "payDay", e.value, "value")}
						/>
					) : (
						<input
							type="number"
							max="31"
							min="1"
							name="payDay"
							className="form-control form-input"
							disabled={disabled}
							value={paySchedule?.payDay?.value}
							onChange={(e) => updateSetting(paySchedule?.id, e.target.name, e.target.value, "value")}
						/>
					)}
				</div>
			</div>
			<div className={`col-xs-${["of the period"].includes(paySchedule?.payDay?.type) ? 2 : 3} pl-0`}>
				<div className="form-material">
					<label></label>
					<Select
						options={
							payFrequency == 12 ? payDayOptions : payDayOptions.filter((p) => p.value != "of the month")
						}
						valueName="selected"
						placeholder="Choose one"
						isDisabled={disabled}
						value={payDayOptions.find((pd) => pd.value == paySchedule?.payDay?.type)}
						onChange={(e) => updateSetting(paySchedule?.id, "payDay", e.value, "type")}
					/>
				</div>
			</div>

			<div className="col-xs-1 pl-0">
				<div
					className="btn btn-default pull-right"
					style={{ marginTop: "1.5rem" }}
					onClick={() => {
						setExpand(!expand);
					}}
				>
					<ChevronDownIcon
						style={{
							height: "1em",
							float: "left",
							transform: expand ? "rotate(180deg)" : "rotate(0deg)",
							transition: "transform 0.2s ease-in-out",
						}}
					/>
				</div>
			</div>
			<div className="clearfix" />

			{expand && (
				<>
					<div className="col-xs-3 pl-0">
						{hasMultipleSchedules && (
							<>
								<label>
									Bank Payroll Reference Number
									<a
										href="https://support.buddy.hr/hc/en-mt/articles/360011709360-Setting-up-Pay-Schedules"
										target="_blank"
										className="h-7 w-7"
									>
										<Tooltip
											as={"span"}
											content="Insert a reference number to ensure that each bank file has a unique name. Click to read more."
										>
											<InformationCircleIcon
												className="h-6 w-6"
												style={{ verticalAlign: "sub" }}
											/>
										</Tooltip>
									</a>
								</label>
								<div
									className="form-material"
									style={{ margin: 0 }}
								>
									<input
										name="addToMillis"
										className="form-control form-input"
										defaultValue={paySchedule?.addToMillis || 0}
										disabled={disabled}
										onChange={(e) => {
											updateSetting(
												paySchedule?.id,
												e.target.name,
												validateInteger(e.target.value),
											);
										}}
									/>
								</div>
							</>
						)}
					</div>
					<div className="col-xs-4 pl-0">
						<label>Timesheet/Overtime Cut-off</label>
						<div
							className={`col-xs-${
								["of the period"].includes(paySchedule?.overtimeCutOff?.type) ? 6 : 3
							} pl-0 pr-0`}
						>
							<div
								className="form-material"
								style={{ margin: 0 }}
							>
								{["of the period"].includes(paySchedule?.overtimeCutOff?.type) ? (
									<Select
										options={cutOffsDurationOptions}
										valueName="selected"
										placeholder="Choose one"
										isDisabled={disabled}
										value={cutOffsDurationOptions.find(
											(pdDuration) => pdDuration.value == paySchedule?.overtimeCutOff?.value,
										)}
										onChange={(e) =>
											updateSetting(paySchedule?.id, "overtimeCutOff", e.value, "value")
										}
									/>
								) : (
									<input
										type="number"
										max="31"
										min="1"
										name="overtimeCutOff"
										className="form-control form-input"
										disabled={disabled}
										value={paySchedule?.overtimeCutOff?.value}
										onChange={(e) =>
											updateSetting(paySchedule?.id, e.target.name, e.target.value, "value")
										}
									/>
								)}
							</div>
						</div>
						<div
							className={`col-xs-${
								["of the period"].includes(paySchedule?.overtimeCutOff?.type) ? 6 : 9
							} pr-0 pl-0`}
						>
							<div
								className="form-material"
								style={{ margin: 0 }}
							>
								<label></label>
								<Select
									options={
										payFrequency == 12
											? cutOffOptions
											: cutOffOptions.filter((p) => p.value != "of the month")
									}
									valueName="selected"
									placeholder="Choose one"
									isDisabled={disabled}
									value={cutOffOptions.find((pd) => pd.value == paySchedule?.overtimeCutOff?.type)}
									onChange={(e) => updateSetting(paySchedule?.id, "overtimeCutOff", e.value, "type")}
								/>
							</div>
						</div>
					</div>
					<div className="col-xs-4 pl-0">
						<label>Leave Cut-off</label>
						<div
							className={`col-xs-${
								["of the period"].includes(paySchedule?.leaveCutOff?.type) ? 6 : 3
							} pl-0 pr-0`}
						>
							<div
								className="form-material"
								style={{ margin: 0 }}
							>
								{["of the period"].includes(paySchedule?.leaveCutOff?.type) ? (
									<Select
										options={cutOffsDurationOptions}
										valueName="selected"
										placeholder="Choose one"
										isDisabled={disabled}
										value={cutOffsDurationOptions.find(
											(pdDuration) => pdDuration.value == paySchedule?.leaveCutOff?.value,
										)}
										onChange={(e) =>
											updateSetting(paySchedule?.id, "leaveCutOff", e.value, "value")
										}
									/>
								) : (
									<input
										type="number"
										max="31"
										min="1"
										name="leaveCutOff"
										className="form-control form-input"
										disabled={disabled}
										value={paySchedule?.leaveCutOff?.value}
										onChange={(e) =>
											updateSetting(paySchedule?.id, e.target.name, e.target.value, "value")
										}
									/>
								)}
							</div>
						</div>
						<div
							className={`col-xs-${
								["of the period"].includes(paySchedule?.leaveCutOff?.type) ? 6 : 9
							} pr-0 pl-0`}
						>
							<div
								className="form-material"
								style={{ margin: 0 }}
							>
								<label></label>
								<Select
									options={
										payFrequency == 12
											? cutOffOptions
											: cutOffOptions.filter((p) => p.value != "of the month")
									}
									valueName="selected"
									placeholder="Choose one"
									isDisabled={disabled}
									value={cutOffOptions.find((pd) => pd.value == paySchedule?.leaveCutOff?.type)}
									onChange={(e) => updateSetting(paySchedule?.id, "leaveCutOff", e.value, "type")}
								/>
							</div>
						</div>
					</div>
				</>
			)}
			<div className="clearfix" />
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const payDeadlineOptions = [
		{ label: "days before payday", value: "days" },
		{ label: "of the month", value: "of the month" },
	];

	const payDayOptions = [
		{ label: "day of the month", value: "of the month" },
		{ label: "of the period", value: "of the period" },
		{ label: "days after end of period", value: "days" },
		{ label: "working days after end of period", value: "workingdays" },
	];

	const payDayDurationOptions = [
		{ label: "last Monday", value: "last Monday" },
		{ label: "last Tuesday", value: "last Tuesday" },
		{ label: "last Wednesday", value: "last Wednesday" },
		{ label: "last Thursday", value: "last Thursday" },
		{ label: "last Friday", value: "last Friday" },
		{ label: "last day", value: "last day" },
	];

	const cutOffOptions = [
		{ label: "day of the month", value: "of the month" },
		{ label: "of the period", value: "of the period" },
		{ label: "before end of period", value: "days" },
	];

	const cutOffsDurationOptions = [
		{ label: "last Monday", value: "last Monday" },
		{ label: "last Tuesday", value: "last Tuesday" },
		{ label: "last Wednesday", value: "last Wednesday" },
		{ label: "last Thursday", value: "last Thursday" },
		{ label: "last Friday", value: "last Friday" },
		{ label: "last Saturday", value: "last Saturday" },
		{ label: "last Sunday", value: "last Sunday" },
		{ label: "last day", value: "last day" },
	];

	const type = ownProps?.paySchedule?.type;
	const payFrequency = ownProps.paySchedule?.payFrequency;
	const payPeriods = state.payPeriods?.periods;

	return {
		payFrequencyOptions,
		payDeadlineOptions:
			type === "4-4-5" || payFrequency !== 12
				? payDeadlineOptions.filter((p) => p.value != "of the month")
				: payDeadlineOptions,
		payDayOptions:
			type === "4-4-5" || payFrequency !== 12
				? payDayOptions.filter((p) => p.value != "of the month")
				: payDayOptions,
		payDayDurationOptions,
		disabled:
			state?.permissions?.my?.permissions?.settings == "Read" || state?.company?.settings?.status == "Archived",
		payFrequency,
		payDeadlineType: ownProps?.paySchedule?.deadline?.type,
		payDayType: ownProps?.paySchedule?.payDay?.type,
		type,
		periodsUsingSchedule: payPeriods?.filter((p) => p.paySchedule == ownProps?.paySchedule?.id)?.length,
		hasMultipleSchedules: state?.company?.settings?.paySchedules?.length > 1,
		cutOffsDurationOptions,
		cutOffOptions,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getPayPeriods: () => dispatch(PAYPERIODACTIONS.getPayPeriods()),
	updateSetting: (id, field, newValue, fieldType) =>
		dispatch(PAYSCHEDULEACTIONS.updateSetting(id, field, newValue, false, fieldType)),
	showUpdatePeriodTypeModal: (id, status) => dispatch(COMPANYACTIONS.showUpdatePeriodTypeModal(id, status)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaySchedule);
